import React from "react";
import { Check, Phone, Clock, MapPin } from "lucide-react";
import { CONTACT, IMAGES } from "@/data/content";

const POINTS = [
  "Personally on-site for every project",
  "Transparent, written estimates — no surprises",
  "Insurance claim documentation handled for you",
  "Premium materials built for Arizona's climate",
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative h-[420px] lg:h-[560px]">
              <img
                src={IMAGES.about}
                alt="Schuyler Corder, roofing professional"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
            {/* Badge */}
            <div className="absolute -bottom-6 -right-2 sm:right-6 bg-[#D86C1E] text-white p-6 max-w-[220px]">
              <div className="font-heading text-4xl font-black leading-none">18+</div>
              <div className="text-xs uppercase tracking-wider mt-2 text-white/90">
                Years protecting Arizona roofs
              </div>
            </div>
          </div>

          {/* Text */}
          <div>
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#D86C1E] mb-4">
              Meet Your Roofer
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tight leading-tight text-[#0A0A0A]">
              Schuyler Corder
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-gray-600">
              Schuyler isn't a faceless company — he's the name on your roof. Through his own
              brand, <span className="font-semibold text-[#0A0A0A]">Blessed Roofing</span> (est.
              2023), and backed by the trusted umbrella of{" "}
              <span className="font-semibold text-[#0A0A0A]">Pro West Roofing</span>, he pairs the
              resources and warranties of an established company with the kind of personal
              accountability you just can't get from a call center.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-gray-600">
              Based in Phoenix and serving all of Arizona and the surrounding area, Schuyler has
              built his reputation one honest handshake at a time. When he says he'll be there, he's
              there — even at 2 AM during monsoon season.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {POINTS.map((p) => (
                <div key={p} className="flex items-start gap-3">
                  <div className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center bg-[#D86C1E]">
                    <Check className="h-3.5 w-3.5 text-white" />
                  </div>
                  <span className="text-sm text-gray-700">{p}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-6 border-t border-[#E5E7EB] pt-8">
              <div className="flex items-center gap-3">
                <Clock className="h-5 w-5 text-[#D86C1E]" />
                <div>
                  <div className="text-xs uppercase tracking-wider text-gray-400">Standard Hours</div>
                  <div className="font-heading font-bold text-[#0A0A0A]">5 AM – 7 PM Daily</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-[#D86C1E]" />
                <div>
                  <div className="text-xs uppercase tracking-wider text-gray-400">Based In</div>
                  <div className="font-heading font-bold text-[#0A0A0A]">{CONTACT.city}</div>
                </div>
              </div>
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 group">
                <Phone className="h-5 w-5 text-[#D86C1E]" />
                <div>
                  <div className="text-xs uppercase tracking-wider text-gray-400">Call Direct</div>
                  <div className="font-heading font-bold text-[#0A0A0A] group-hover:text-[#D86C1E]">
                    {CONTACT.phone}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
